import { render, staticRenderFns } from "./TagComponent.vue?vue&type=template&id=0943ce32&scoped=true&functional=true&"
import script from "./TagComponent.vue?vue&type=script&lang=js&"
export * from "./TagComponent.vue?vue&type=script&lang=js&"
import style0 from "./TagComponent.vue?vue&type=style&index=0&id=0943ce32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "0943ce32",
  null
  
)

export default component.exports